{
	"meta": {
		"title": "Pricing — UpSquad",
		"description": "Simple pricing. Start free with no credit card required, then upgrade when you're ready to grow."
	},
	"hero": {
		"eyebrow": "Pricing",
		"title": "Simple pricing.",
		"title_accent": "Real results.",
		"subtitle": "Start free. No credit card required. Upgrade when your community is ready to grow."
	},
	"billing": {
		"monthly": "Monthly",
		"annual": "Annual",
		"save": "Save 20%"
	},
	"tiers": {
		"free": {
			"tagline": "Start here",
			"name": "Free",
			"price": "$0",
			"period": "14-day trial",
			"description": "For getting started — try every core feature with up to 25 members.",
			"cta": "Sign up free",
			"footnote": "No credit card required",
			"features": [
				"Social feed and direct messaging",
				"Member directory",
				"Up to 25 members",
				"Admin panel",
				"Your community URL (yourorg.upsquad.us)"
			]
		},
		"pro": {
			"tagline": "For growing communities",
			"name": "Pro",
			"price_monthly": "$9",
			"price_annual": "$7",
			"period": "/user/month",
			"badge": "Most popular",
			"description": "Unlock AI Insights, Match AI, and unlimited members.",
			"cta": "Start Pro trial",
			"footnote": "14-day free trial included",
			"features": [
				"Everything in Free",
				"Unlimited members",
				"AI Insights — ask anything about your community",
				"Match AI — networking + 1:1 scheduling",
				"Events (free + paid, with attendance tracking)",
				"Community clips and video reels",
				"Advanced analytics dashboard",
				"Cohorts and groups",
				"Priority support"
			]
		},
		"premium": {
			"tagline": "For organizations ready to scale",
			"name": "Premium",
			"price": "Custom",
			"badge": "Branded app",
			"description": "Everything in Pro, plus a fully branded mobile app live in 72 hours.",
			"cta": "Contact sales",
			"footnote": "Pricing based on community size and needs",
			"features": [
				"Everything in Pro",
				"Branded iOS and Android app — live in 72 hours",
				"App Store management (we handle submissions)",
				"MCP server for enterprise integrations",
				"Custom integrations with your existing tools",
				"Dedicated onboarding support",
				"SLA-backed uptime guarantee",
				"Custom contract and invoicing"
			]
		}
	},
	"faq": {
		"title": "Frequently asked questions",
		"items": {
			"trial": {
				"question": "What happens after my 14-day free trial?",
				"answer": "Your community keeps running on the Free plan (up to 25 members) automatically. You can upgrade to Pro at any time to unlock unlimited members and AI features."
			},
			"change_plan": {
				"question": "Can I change my plan at any time?",
				"answer": "Yes. Upgrade, downgrade or cancel from your admin panel — changes take effect immediately, with prorated billing."
			},
			"per_user": {
				"question": "How does per-user pricing work?",
				"answer": "Pro is billed per active member per month. You only pay for members who actually log in and use UpSquad."
			},
			"branded_app": {
				"question": "What's included in the branded mobile app?",
				"answer": "A fully branded iOS and Android app with your logo, name, colors and content — published to the App Store and Google Play under your brand. We handle submissions, updates and ongoing maintenance."
			},
			"setup_fee": {
				"question": "Is there a setup fee?",
				"answer": "No setup fee on Free or Pro. Premium customers receive dedicated white-glove onboarding included with the plan."
			},
			"discounts": {
				"question": "Do you offer discounts for nonprofits or educational organizations?",
				"answer": "Yes — we offer meaningful discounts for verified nonprofits, schools and community-based organizations. Contact sales for details."
			},
			"match_ai": {
				"question": "What is Match AI and how does it work?",
				"answer": "Match AI analyzes member profiles, goals and activity to recommend the right connections at the right time, then lets members schedule a 1:1 meeting in one click."
			},
			"mcp": {
				"question": "What is the MCP server in the Premium plan?",
				"answer": "An optional Model Context Protocol server that lets your community data and tools securely connect to external AI assistants and enterprise systems."
			}
		}
	}
}
